<h2>Checkboxes</h2>

<div class="controls-grid">
	<div class="control-column">
		<span class="label">Basic Checkbox</span>
		<app-checkbox
			[(ngModel)]="checkboxControl1.value"
			label="Accept terms and conditions"
			helperText="Please read our terms before proceeding"
		/>
		<app-ui-code-block [code]="generateCheckboxCode({ngModel: 'checkboxValue', label: 'Accept terms and conditions', helperText: 'Please read our terms before proceeding'})" />
	</div>

	<div class="control-column">
		<span class="label">Disabled Checkbox</span>
		<app-checkbox
		[(ngModel)]="checkboxControl4.value"
		label="Unchecked disabled"
		[disabled]="true"
	/>
		<app-checkbox
			[(ngModel)]="checkboxControl2.value"
			label="Disabled option"
			helperText="This option is currently unavailable"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCheckboxCode({ngModel: 'checkboxValue', label: 'Disabled option', helperText: 'This option is currently unavailable', disabled: true})" />
	</div>

	<div class="control-column">
		<span class="label">Error Checkbox</span>
		<app-checkbox
			[(ngModel)]="checkboxControl3.value"
			label="Error option"
			helperText="You must accept to continue"
			[error]="true"
		/>
		<app-ui-code-block [code]="generateCheckboxCode({ngModel: 'checkboxValue', label: 'Error option', helperText: 'You must accept to continue', error: true})" />
	</div>
</div>

<h2>Radio Buttons</h2>

<div class="controls-grid">
	<div class="control-column">
		<span class="label">Basic Radio</span>
		<div class="radio-group">
			<app-radio-button
				[value]="'option1'"
				[selectedValue]="radioControl1.value"
				(selectedValueChange)="radioControl1.setValue($event)"
				[inputId]="'radio-option1'"
				label="Option 1"
			/>
			<app-radio-button
				[value]="'option2'"
				[selectedValue]="radioControl1.value"
				(selectedValueChange)="radioControl1.setValue($event)"
				[inputId]="'radio-option2'"
				label="Option 2"
			/>
			<app-radio-button
				[value]="'option3'"
				[selectedValue]="radioControl1.value"
				(selectedValueChange)="radioControl1.setValue($event)"
				[inputId]="'radio-option3'"
				label="Option 3"
			/>
		</div>
		<app-ui-code-block [code]="generateRadioCode({value: 'option1', selectedValue: 'selectedValue', selectedValueChange: 'onRadioChange($event)', inputId: 'radio-option1', label: 'Option 1'})" />
	</div>

	<div class="control-column">
		<span class="label">Disabled Radio</span>
		<app-radio-button
			[value]="'disabled'"
			[selectedValue]="radioControl2.value"
			(selectedValueChange)="radioControl2.setValue($event)"
			[inputId]="'radio-disabled'"
			label="Disabled option"
			helperText="This option is currently unavailable"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateRadioCode({value: 'disabled', selectedValue: 'selectedValue', selectedValueChange: 'onRadioChange($event)', inputId: 'radio-disabled', label: 'Disabled option', helperText: 'This option is currently unavailable', disabled: true})" />
	</div>

	<div class="control-column">
		<span class="label">Error Radio</span>
		<app-radio-button
			[value]="'error'"
			[selectedValue]="radioControl3.value"
			(selectedValueChange)="radioControl3.setValue($event)"
			[inputId]="'radio-error'"
			label="Error option"
			helperText="You must select this to continue"
			[error]="true"
		/>
		<app-ui-code-block [code]="generateRadioCode({value: 'error', selectedValue: 'selectedValue', selectedValueChange: 'onRadioChange($event)', inputId: 'radio-error', label: 'Error option', helperText: 'You must select this to continue', error: true})" />
	</div>
</div>

<h2>Switches</h2>

<div class="controls-grid">
	<div class="control-column">
		<span class="label">Basic Switch</span>
		<app-toggle-switch
			[(ngModel)]="switchControl1.value"
		/>
		<app-ui-code-block [code]="generateSwitchCode({ngModel: 'switchValue'})" />
	</div>

	<div class="control-column">
		<span class="label">Disabled Switch</span>
		<app-toggle-switch
			[(ngModel)]="switchControl2.value"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateSwitchCode({ngModel: 'switchValue', disabled: true})" />
	</div>

	<div class="control-column">
		<span class="label">Checked Switch</span>
		<app-toggle-switch
			[(ngModel)]="switchControl3.value"
		/>
		<app-ui-code-block [code]="generateSwitchCode({ngModel: 'switchValue'})" />
	</div>
</div>
